import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { Container, ContentContainer, Title } from "./styles";
import SurveysTable from "./SurveysTable";
import SurveysTemplateTable from "./SurveysTemplateTable";

export default function ListSurveys() {
  return (
    <Container>
      <AdminMenu />
      <ContentContainer>
        <SurveysTemplateTable />
        <SurveysTable />
      </ContentContainer>
    </Container>
  );
}